import {
  route,
} from '@app/Routing/helpers'
import { accessPermission } from '@access/permissions'

import {
  ALL,
} from '@app/Seller/accessTokens'

const ChatBase = () => import('@app/Seller/Components/Base')
const ChatList = () => import('@app/Seller/Chats/List')

const MODEL = 'chat'

const BASE = `${MODEL}/`
// const u = url => BASE + url

const ORDERS_LIST = 'orders/'
const PRODUCTS_LIST = 'products/'
const SELLER_LIST = 'questions/'

export const CHAT_PREFIX = `${MODEL}:`
const p = name => CHAT_PREFIX + name

export const CHAT_BASE_NAME = p('base')
export const CHAT_ORDERS_LIST_NAME = p('orders')
export const CHAT_PRODUCTS_LIST_NAME = p('products')
export const CHAT_SELLER_LIST_NAME = p('seller')

const ORDERS_CHAT_KEY = 'orders-chat-launcher'
const PRODUCTS_CHAT_KEY = 'products-chat-launcher'
const SELLER_CHAT_KEY = 'seller-chat-launcher'

export function createRoutes(options) {
  return [
    route(BASE, ChatBase, CHAT_BASE_NAME, {
      meta: accessPermission(ALL, options),
      redirect: { name: CHAT_PRODUCTS_LIST_NAME },
      children: [
        route(ORDERS_LIST, ChatList, CHAT_ORDERS_LIST_NAME, {
          meta: {
            ...accessPermission(ALL, options),
            tag: ORDERS_CHAT_KEY,
          },
        }),
        route(PRODUCTS_LIST, ChatList, CHAT_PRODUCTS_LIST_NAME, {
          meta: {
            ...accessPermission(ALL, options),
            tag: PRODUCTS_CHAT_KEY,
          },
        }),
        route(SELLER_LIST, ChatList, CHAT_SELLER_LIST_NAME, {
          meta: {
            ...accessPermission(ALL, options),
            tag: SELLER_CHAT_KEY,
          },
        }),
      ],
    }),
  ]
}
